import React from 'react';
import { NavLink } from 'react-router';
import { useContent } from '../../hooks/useContent';
import { articleSubmissionEn } from '../../content/articleSubmissionEn';
import styles from './ArticleSubmission.module.css';

const ArticleSubmission = () => {
  const { t } = useContent();
  const j = articleSubmissionEn.journalCard;
  const tpl = articleSubmissionEn.templatesCard;

  const guidelinesPath = t('articleSubmission.templatesCard.guidelinesPath', tpl.guidelinesPath);
  const easyChair = t('articleSubmission.templatesCard.easyChairUrl', tpl.easyChairUrl);

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>{t('articleSubmission.pageTitle', articleSubmissionEn.pageTitle)}</h1>

      <div className={styles.cardsContainer}>
        <div className={styles.card}>
          <div className={styles.cardHeader}>
            <div className={styles.iconWrapper}>
              <svg className={styles.icon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
              </svg>
            </div>
            <h2 className={styles.cardTitle}>{t('articleSubmission.journalCard.title', j.title)}</h2>
          </div>

          <div className={styles.cardContent}>
            <ul className={styles.list}>
              <li className={styles.listItem}>
                <span className={styles.label}>{t('articleSubmission.journalCard.labelTitle', j.labelTitle)}</span>{' '}
                {t('articleSubmission.journalCard.valueTitle', j.valueTitle)}
              </li>
              <li className={styles.listItem}>
                <span className={styles.label}>{t('articleSubmission.journalCard.labelLanguage', j.labelLanguage)}</span>{' '}
                {t('articleSubmission.journalCard.valueLanguage', j.valueLanguage)}
              </li>
              <li className={styles.listItem}>
                <span className={styles.label}>{t('articleSubmission.journalCard.labelLength', j.labelLength)}</span>{' '}
                {t('articleSubmission.journalCard.valueLength', j.valueLength)}
              </li>
              <li className={styles.listItem}>
                <span className={styles.label}>{t('articleSubmission.journalCard.labelFee', j.labelFee)}</span>{' '}
                {t('articleSubmission.journalCard.valueFee', j.valueFee)}
              </li>
              <li className={styles.listItem}>
                <span className={styles.label}>
                  {t('articleSubmission.journalCard.labelConfFee', j.labelConfFee)}
                </span>{' '}
                {t('articleSubmission.journalCard.valueConfFee', j.valueConfFee)}
              </li>
            </ul>
          </div>
        </div>

        <div className={styles.card}>
          <div className={styles.cardHeader}>
            <div className={styles.iconWrapper}>
              <svg className={styles.icon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                <polyline points="22 4 12 14.01 9 11.01" />
              </svg>
            </div>
            <h2 className={styles.cardTitle}>{t('articleSubmission.templatesCard.title', tpl.title)}</h2>
          </div>

          <div className={styles.cardContent}>
            <ol className={styles.orderedList}>
              <li className={styles.orderedItem}>
                {t('articleSubmission.templatesCard.step1Before', tpl.step1Before)}
                <NavLink to={guidelinesPath} className={styles.link}>
                  {t('articleSubmission.templatesCard.step1LinkText', tpl.step1LinkText)}
                </NavLink>
                {t('articleSubmission.templatesCard.step1After', tpl.step1After)}
              </li>
              <li className={styles.orderedItem}>
                {t('articleSubmission.templatesCard.step2Before', tpl.step2Before)}
                <a href={easyChair} target="_blank" rel="noopener noreferrer" className={styles.link}>
                  {t('articleSubmission.templatesCard.step2LinkText', tpl.step2LinkText)}
                </a>
                {t('articleSubmission.templatesCard.step2After', tpl.step2After)}
              </li>
              <li className={styles.orderedItem}>{t('articleSubmission.templatesCard.step3', tpl.step3)}</li>
              <li className={styles.orderedItem}>{t('articleSubmission.templatesCard.step4', tpl.step4)}</li>
              <li className={styles.orderedItem}>{t('articleSubmission.templatesCard.step5', tpl.step5)}</li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ArticleSubmission;
